module.exports = __webpack_public_path__ + "img/feature_6.c45f4a09.png";